import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  modalContent: {
    '& .MuiTypography-root': {
      paddingBottom: '8px'
    }
  },
  buttons: {
    display: 'flex',
    paddingBottom: '16px',
    justifyContent: 'flex-end',
    width: '100%'
  },
  permissionSelection: {
    marginRight: '8px',
    width: '200px'
  },
  changesMadeWrapper: {
    marginTop: '16px',
    marginBottom: '0px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start'
  },
  changesMadeWrapperText: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  filterableInput: {
    paddingTop: '16px',
    paddingBottom: '8px'
  },
  header: {
    paddingTop: '16px'
  },
  gridContainer: {
    paddingTop: '16px',
    paddingBottom: '16px',
    maxHeight: 300
  },
  gridTitle: {
    paddingTop: '16px'
  },
  addUserBtn: { marginLeft: '8px', width: '80px' },
  tableContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  saveBtnWithChanges: {
    marginTop: '0px',
    marginBottom: '0px'
  },
  saveBtnBase: {
    marginTop: '32px',
    marginBottom: '16px',
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%'
  },
  listbox: {
    '& .MuiAutocomplete-option': {
      padding: 0
    },
    '& .MuiListItemText-root': {
      margin: 0
    },
    '& .MuiTypography-root': {
      padding: '0px',
      margin: '0px'
    }
  },
  userActionSelect: {
    width: '180px'
  },
  addUserAutocomplete: {
    width: '682px'
  }
});
